import React from 'react'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import LinkComponent from '@professocial/professocialFormComponents/FormComponents/LinkComponent'
import { IPostElementProps } from '../../../../types/types'
import { Typography } from '@mui/material/'

const LinkHeadline: React.FC<IPostElementProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: 'inline-block',
      color: '#646464',
      cursor: 'pointer',
      textDecoration: 'none',
      paddingRight: theme.spacing(1),
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  }))
  const classes = useStyles()
  return (
    <>
      {(props.value?.url) ?
        <LinkComponent
          className={classes.root}
          href={props.value.url}
          underline='none'
          target='_blank'
          variant='h4'
          text={props.value.label}
        /> : (
          <Typography variant='h4' className={classes.root}>{props.value.label}</Typography>
        )}
    </>
  )
}

export default LinkHeadline
